import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 5.39999C8.35682 5.39999 5.40002 8.17199 5.40002 11.5875C5.40002 13.5922 5.81252 14.8875 7.46252 16.5375L12 20.25V17.775C15.6432 17.775 18.6 15.003 18.6 11.5875C18.6 8.17199 15.6432 5.39999 12 5.39999Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})
});
const ForwardRef = forwardRef(SvgChatSmall);
export default ForwardRef;
